import { useMemo } from "react";
import { useCreances } from "@/hooks/queries/useCreances";
import { filterCreances, getCreanceMetrics } from "../creance-calculations";

export function useCreancesPageData(filters: { onlyOverdue: boolean; search: string }) {
  const { data: rows = [], isLoading } = useCreances({ onlyOverdue: filters.onlyOverdue });

  const filteredRows = useMemo(() => filterCreances(rows, filters.search), [filters.search, rows]);
  const metrics = useMemo(() => getCreanceMetrics(rows), [rows]);

  return {
    rows,
    filteredRows,
    metrics,
    isLoading,
  };
}
